import { render, staticRenderFns } from "./AuditoriaOxyflow.vue?vue&type=template&id=1c76678a&scoped=true"
import script from "./AuditoriaOxyflow.vue?vue&type=script&lang=js"
export * from "./AuditoriaOxyflow.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaOxyflow.vue?vue&type=style&index=0&id=1c76678a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c76678a",
  null
  
)

export default component.exports